import { Pipe, PipeTransform } from "@angular/core";
import { formatDate } from "devextreme/localization";

@Pipe({
	name: 'timezoneDate',
	standalone: true,
	pure: true // pure: true ensures the pipe is only recalculated when input changes
  })
  export class TimezoneDatePipe implements PipeTransform {
	transform(date: string, timezone: string, format = 'dd-MM-yyyy HH:mm'): string {
		  // Parse the input date, treating it as UTC by removing the timezone offset
		  const utcDate  = new Date(date);

		  // Use Intl.DateTimeFormat for timezone conversion
		  const formatter = new Intl.DateTimeFormat("en-GB", {
			timeZone: timezone,
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
			hour12: false,
		  });

		  // Format the date in the specified timezone
		  const parts = formatter.formatToParts(utcDate);

		  const localDate = new Date(
			+parts.find(p => p.type === 'year')?.value,
			(+parts.find(p => p.type === 'month')?.value) - 1,  // FIX: Subtract 1 from month, because JS months are 0-based
			+parts.find(p => p.type === 'day')?.value,
			+parts.find(p => p.type === 'hour')?.value,
			+parts.find(p => p.type === 'minute')?.value,
			+parts.find(p => p.type === 'second')?.value
		  );

		  return formatDate(localDate, format);
	}
  }
